// Whole-phrase replacement used by the Canada EN→FR DOM translator.
// A key only matches when it is not glued to another letter or digit, so
// "Help" no longer turns "Helped" into "Aideed" and "Unit" no longer
// rewrites the French word "Unités".

const WORD_CHAR = /[\p{L}\p{N}]/u;

function isBoundary(text, index) {
  if (index < 0 || index >= text.length) return true;
  return !WORD_CHAR.test(text[index]);
}

export function replaceWholePhrase(text, key, replacement) {
  if (!key || !text.includes(key)) return text;
  let result = "";
  let cursor = 0;
  let index = text.indexOf(key, cursor);
  while (index !== -1) {
    const end = index + key.length;
    // Only enforce a boundary on sides where the key itself starts/ends with a word character.
    const startOk = !WORD_CHAR.test(key[0]) || isBoundary(text, index - 1);
    const endOk = !WORD_CHAR.test(key[key.length - 1]) || isBoundary(text, end);
    if (startOk && endOk) {
      result += text.slice(cursor, index) + replacement;
      cursor = end;
    }
    index = text.indexOf(key, startOk && endOk ? end : index + 1);
  }
  return result + text.slice(cursor);
}

// keys must be sorted longest first so longer phrases win over their sub-phrases.
export function replacePhrases(text, dictionary, keys) {
  let translated = String(text);
  for (const key of keys) {
    if (!translated.includes(key)) continue;
    const replacement = dictionary[key];
    if (replacement == null) continue;
    translated = replaceWholePhrase(translated, key, replacement);
  }
  return translated;
}
